import React, { useMemo } from 'react';
import { Provider } from 'mobx-react';
import { Route, Switch } from 'react-router-dom';
import { RootStore } from '../titleReports/services/RootStore';
import { TitleReportAuthWrapper } from '../titleReports/TitleReportAuthWrapper';
import { SearchReportPage } from '../titleReports/pages/SearchReportPage';
import { RequirementsExceptionsPage } from '../titleReports/pages/RequirementsExceptionsPage';
import { ErrorBoundaryTW } from '../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { useRouteMatch } from 'react-router';

export const TitleReportRouter: React.FC = () => {
  const rootStore = useMemo(() => new RootStore(), []);
  const { path } = useRouteMatch();

  return (
    <ErrorBoundaryTW>
      <Provider rootStore={rootStore}>
        <TitleReportAuthWrapper rootStore={rootStore}>
          <Switch>
            <Route path={`${path}/searchReport/:action`} component={SearchReportPage} />
            <Route path={`${path}/searchReportExceptions/:action`} component={RequirementsExceptionsPage} />
          </Switch>
        </TitleReportAuthWrapper>
      </Provider>
    </ErrorBoundaryTW>
  );
};
